import React, { FC, ReactElement, ReactNode } from 'react'
import { UserInfoContextProvider } from '../Contexts'
import { BaseContexts } from '../BaseContexts'

type Props = {
    disableError?: boolean
    children: ReactNode
}

export const StandardContexts: FC<Props> = ({ children, disableError }: Props): ReactElement => (
    <BaseContexts>
        <UserInfoContextProvider disableError={disableError}>{children}</UserInfoContextProvider>
    </BaseContexts>
)
